/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Pondelok", "Utorok", "Streda", "\u0160tvrtok", "Piatok", "Sobota", "Nede\u013Ea"], a = ["Janu\xE1r", "Febru\xE1r", "Marec", "Apr\xEDl", "M\xE1j", "J\xFAn", "J\xFAl", "August", "September", "Okt\xF3ber", "November", "December"], t = "Roky", s = "Rok", o = "Mesiac", d = "T\xFD\u017Ede\u0148", r = "De\u0148", n = "Dnes", l = "Bez udalosti", y = "Cel\xFD de\u0148", k = "Odstr\xE1ni\u0165", M = "Vytvori\u0165 udalos\u0165", D = "dddd D. MMMM YYYY", i = { weekDays: e, months: a, years: "Roky", year: "Rok", month: "Mesiac", week: "T\xFD\u017Ede\u0148", day: "De\u0148", today: "Dnes", noEvent: "Bez udalosti", allDay: "Cel\xFD de\u0148", deleteEvent: "Odstr\xE1ni\u0165", createEvent: "Vytvori\u0165 udalos\u0165", dateFormat: "dddd D. MMMM YYYY" };
export {
  y as allDay,
  M as createEvent,
  D as dateFormat,
  r as day,
  i as default,
  k as deleteEvent,
  o as month,
  a as months,
  l as noEvent,
  n as today,
  d as week,
  e as weekDays,
  s as year,
  t as years
};
